export default "__VITE_ASSET__KGPtWed___"